import { render, staticRenderFns } from "./IndexIt.vue?vue&type=template&id=425fbdba&scoped=true&"
import script from "./IndexIt.vue?vue&type=script&lang=js&"
export * from "./IndexIt.vue?vue&type=script&lang=js&"
import style0 from "./IndexIt.vue?vue&type=style&index=0&id=425fbdba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425fbdba",
  null
  
)

export default component.exports